module.exports = __webpack_public_path__ + "static/wrkat-env2-min-240bcef51eae027df5aec86cd8bf2023.jpg";